// Outer padding of the student Show sections that are not wrapped in react-admin's <SimpleShowLayout>.
// Same as SimpleShowLayout's own padding (8px 16px), so every section's box sits at the same distance
// below its SectionTitle and spans the same width, whichever wrapper it uses.
export const sectionWrapperSx = { px: 2, py: 1 };
